"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const classnames_1 = __importDefault(require("classnames"));
const InputField = ({ label, ...props }) => {
    const [field, { touched, error }, helpers] = (0, formik_1.useField)(props.name);
    const id = props.id ? props.id : props.name;
    return (react_1.default.createElement("div", { className: "space-y-1" },
        react_1.default.createElement("label", { htmlFor: id, className: "block text-sm font-medium text-gray-700" }, label),
        react_1.default.createElement("div", { className: "mt-1 relative rounded-md shadow-sm" },
            react_1.default.createElement("input", { ...props, ...field, value: field.value ?? '', id: id, className: (0, classnames_1.default)("form-input", error ? '--error' : '') }),
            touched && error ? (react_1.default.createElement("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" },
                react_1.default.createElement("svg", { className: "h-5 w-5 text-red-500", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" },
                    react_1.default.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z", clipRule: "evenodd" })))) : null),
        touched && error ? react_1.default.createElement("p", { className: "mt-2 text-sm text-red-600", id: "email-error" }, error[0]) : ''));
};
exports.default = InputField;
